export default __webpack_public_path__ + "static/SuccessStoriesGovernment-d07daf5c26e63269cd008ea389a163f3.png";